import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
export const Input = forwardRef(({ className, ...props }, ref) => {
    const baseStyle = 'w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm text-gray-600 placeholder:text-gray-400 transition-colors duration-200 focus:outline-none focus:border-interactive-emerald-flash focus:ring-1 focus:ring-interactive-emerald-flash';
    return _jsx("input", { className: `${baseStyle} ${className || ''}`, ref: ref, ...props });
});
Input.displayName = 'Input';
//# sourceMappingURL=Input.js.map